import React, { useCallback, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import {
  selectBudgetRevisions,
  selectCreditCardIdFromRoute,
  selectFullyLoadedRevisionsFromState,
  selectRevisionsLoadingFromState,
  selectRevisionsPaginationFromState,
} from 'src/app/BudgetHistory/redux/budgetHistory.selectors'
import { selectCreditCard } from 'src/app/BudgetOverview/redux/budgetOverview.selectors'
import BackgroundPageContent from 'src/components/BackgroundPageContent/BackgroundPageContent'
import Box from 'src/components/Box/Box'
import BudgetHistoryTable from 'src/components/BudgetHistoryTable/BudgetHistoryTable'
import { useBackgroundDispatch } from 'src/hooks'
import { getBudgetRevisions } from 'src/redux/actions/data/budgetRevisions.actions'
import { selectUserIdFromState } from 'src/redux/selectors/auth.selectors'
import { css } from 'styled-components'

const BudgetHistory: React.FC = () => {
  const dispatch = useBackgroundDispatch()
  const revisions = useSelector(selectBudgetRevisions)
  const revisionsPagination = useSelector(selectRevisionsPaginationFromState)
  const creditCardId = useSelector(selectCreditCardIdFromRoute)
  const userId = useSelector(selectUserIdFromState)
  const creditCard = useSelector(selectCreditCard)
  const revisionsLoading = useSelector(selectRevisionsLoadingFromState)
  const fullyLoadedRevisions = useSelector(selectFullyLoadedRevisionsFromState)
  const [currentPagination, setCurrentPagination] =
    useState(revisionsPagination)

  useEffect(() => {
    if (creditCard !== undefined && !revisionsLoading) {
      dispatch(
        getBudgetRevisions(creditCardId, {
          limit: 5,
          previousCursor: revisionsPagination?.previousCursor,
        }),
      )
      setCurrentPagination(revisionsPagination)
    }
  }, [creditCard])

  const fetchMoreRevisions = useCallback((): void => {
    if (
      !revisionsLoading &&
      revisionsPagination?.nextCursor !== currentPagination?.nextCursor
    ) {
      dispatch(
        getBudgetRevisions(creditCardId, {
          limit: 5,
          nextCursor: revisionsPagination?.nextCursor,
        }),
      )
      setCurrentPagination(revisionsPagination)
    }
  }, [revisionsPagination])

  return (
    <BackgroundPageContent
      css={css`
        padding: 40px;
      `}
    >
      <Box noPadding>
        <BudgetHistoryTable
          revisions={revisions}
          userId={userId}
          timezone={creditCard?.timezone}
          currency={creditCard?.currency}
          fetchMoreRevisions={fetchMoreRevisions}
          fullyLoadedRevisions={fullyLoadedRevisions}
          revisionsLoading={revisionsLoading}
        />
      </Box>
    </BackgroundPageContent>
  )
}

export default BudgetHistory
